import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as space from '../../space'

export const RESOURCE = {
  payload: {
    description:
      'A physical location that encompasses multiple buildings and facilities supporting research and education.',
    dimension: space.RESOURCE.payload,
    level: 0,
    name: 'Campus',
    partialId: PartialId.Standard.create('campus'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
